import { Box, Paper, Typography, Button } from '@mui/material';
import React from 'react';
const classes = {
    root: {
        position: 'fixed',
        bottom: 20,
        left: '10%',
        right: 0,
        transform: 'translate(-10%)',
        padding: 2,
        overflow: 'hidden',
        maxWidth: '90%',
        zIndex: 1000,
    },
    card: {
        textAlign: 'left',
        color: 'rgba(0, 0, 0, 0.6)',
        transition: 'max-height 0.3s ease-out',
        margin: '1em',
        padding: '1em',
    },
};
const CookieBanner = () => {
    const text = 'This service uses strictly necessary cookies exclusively to collect aggregated and anonymised ' +
        'information on the quality and effectiveness of the service provided to society. These cookies ' +
        'do not involve the processing of personal data and have no impact on the privacy of subscribers ' +
        'or users. Their use is strictly limited to what is necessary for the operation and improvement ' +
        'of the service, in accordance with applicable EU legislation.';
    const localStorageIem = 'cookieBannerDismissed';
    // initiate state: check if value in localStorage else false
    const [bannerVisible, setBannerVisible] = React.useState(() => {
        return localStorage.getItem(localStorageIem) !== 'true';
    });
    const handleDismiss = () => {
        setBannerVisible(false);
        localStorage.setItem(localStorageIem, 'true');
    };
    return (React.createElement(Box, { className: `cookie-banner ${bannerVisible ? 'expanded' : 'collapsed'}`, sx: Object.assign(Object.assign({}, classes.root), { maxHeight: bannerVisible ? '500px' : '120px' }) }, bannerVisible && (React.createElement(Paper, { sx: classes.card, elevation: 5 },
        React.createElement(Typography, { variant: 'h6' }, "Cookies & trackers notice"),
        React.createElement(Typography, null, text),
        React.createElement(Button, { color: 'primary', onClick: handleDismiss }, "Acknowledge & continue")))));
};
export default CookieBanner;
